import { render, staticRenderFns } from "./MagicLinkPost.vue?vue&type=template&id=a68da4f2&scoped=true&"
import script from "./MagicLinkPost.vue?vue&type=script&lang=js&"
export * from "./MagicLinkPost.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkPost.vue?vue&type=style&index=0&id=a68da4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68da4f2",
  null
  
)

export default component.exports